<template>
  <div v-if="isPermission && isEditData">
    <div class="row" style="margin: 5px">
      <div class="col-md-10">
        <h2 class="font-weight-normal">
          {{ $t('createStockIn') }}
        </h2>
      </div>
    </div>

    <!-- Body information -->
    <CCol md="12" lg="12">
      <CCard class="shadow-sm">
        <CCardBody>
          <CAlert color="danger" :show.sync="isshowAlert" closeButton>
            {{ $t('limitItems') }}
          </CAlert>
          <CAlert color="success" v-if="isSuccess === true" id="createStockInAlertSuccess">
            {{ $t('dialogSaveDocumentSuccess') }}
          </CAlert>
          <div class="row">
            <div class="col-md-12 col-12">
              <h4 class="font-weight-normal">
                {{ $t('information') }}
              </h4>
            </div>
          </div>
          <br />
          <div class="form-group row">
            <label class="col-12 col-md-2 col-form-label text-sm-right text-left">
              {{ $t('dateOfBill') }}
            </label>
            <div class="col-12 col-md-4">
             <v-date-picker
                v-model="datetime"
                :locale="getDateLocale()"
                :popover="{ visibility: 'click', placement: 'bottom-start' }"
              >
                <template v-slot="{ inputValue, togglePopover }">
                  <input
                    id="createStockInDatePickerInput"
                    :value="inputValue"
                    @click="togglePopover"
                    readonly
                    class="form-control text-dark"
                  />
                </template>
              </v-date-picker>
              <!-- <VueDatePicker id="createStockInDatePicker" color="#29B46B" :locale="getDateLocale()" :visible-years-number="90" v-model="datetime"
                format="DD-MM-YYYY" class="form-control text-dark">
                <template v-slot="{ inputValue, inputEvents }">
                  <input id="createStockInDatePickerInput" :value="inputValue" v-on="inputEvents" />
                </template>
              </VueDatePicker> -->
            </div>
            <label class="col-12 col-md-2 col-form-label text-sm-right text-left">
              {{ $t('billNo') }}
            </label>
            <div class="col-12 col-md-4">
              <input id="createStockInBillNoInput" class="form-control text-dark" v-model="billNo" :placeholder="$t('billNo')" />
            </div>
          </div>
          <div class="form-group row text-sm-right text-left">
            <label class="col-12 col-md-2 col-form-label">
              {{ $t('shop') }}
            </label>
            <div class="col-12 col-md-4">
              <select id="createStockInShopSelect" class="custom-select text-dark" v-model="shopObjectId" disabled>
                <option id="createStockInShopOption" v-for="shop in shops" :key="shop.objectId" :value="shop.objectId">
                  {{ shop.shopName }} - {{ shop.branchName }}
                </option>
              </select>
              <div v-if="validateShop" class="text-danger" id="createStockInShopValidation">
                {{ validateShop }}
              </div>
            </div>
            <label class="col-12 col-md-2 col-form-label text-sm-right text-left">
              {{ $t('customer') }}
            </label>
            <div class="col-12 col-md-4">
              <multiselect v-model="member" :options="memberslist" label="name" track-by="name" :placeholder="$t('customer')" :select-label="$t('pressEnterSelect')" :selected-label="$t('selected')"
                :deselect-label="$t('pressEnterRemove')" id="createStockInCustomerMultiselect"></multiselect>
            </div>
          </div>
          <div v-show="refDocPO" class="form-group row">
            <label class="col-12 col-md-2 col-form-label text-sm-right text-left">
              {{ $t('refNo') }}
            </label>
            <div class="col-12 col-md-4">
              <input id="createStockInBillNoInput" class="form-control text-dark" v-model="refDocPO" disabled :placeholder="$t('refNo')" />
            </div>
            <label class="col-12 col-md-2 col-form-label text-sm-right text-left">
              {{ $t('createdRefDocDate') }}
            </label>
            <div class="col-12 col-md-4">
              <!-- <VueDatePicker id="createStockInDatePicker" color="#29B46B" disabled :locale="getDateLocale()" :visible-years-number="90" v-model="refDocCreateAt"
                format="DD-MM-YYYY" class="form-control text-dark">
                <template v-slot="{ inputValue, inputEvents }">
                  <input id="createStockInDatePickerInput" :value="inputValue" v-on="inputEvents" />
                </template>
              </VueDatePicker>             -->
              <v-date-picker
                v-model="refDocCreateAt"
                :locale="getDateLocale()"
                :popover="{ visibility: 'click', placement: 'bottom-start' }"
                :disabled="true"
              >
                <template v-slot="{ inputValue }">
                  <input
                    id="createStockInDatePickerInput"
                    :value="formatDate(inputValue)"
                    readonly
                    disabled
                    class="form-control text-dark"
                  />
                </template>
              </v-date-picker>
            </div>
          </div>
          <div class="form-group row">
            <label class="col-12 col-md-2 col-form-label text-sm-right text-left">
              {{ $t('reason') }}
            </label>
            <div class="col-12 col-md-10">
              <textarea id="createStockInReasonTextarea" v-model="note" class="form-control text-dark" :placeholder="$t('reason')" />
            </div>
          </div>
        </CCardBody>
      </CCard>
    </CCol>

    <!-- Data table -->
    <CCol>
      <CCard class="shadow-sm">
        <CCardBody>
          <div class="row">
            <div class="col-md-4">
              <h4 class="font-weight-normal">
                {{ $t('stockinList') }}
              </h4>
              <p class="text-dark">
                {{ $t('addProductStockin') }}
              </p>
            </div>
            <!-- <div class="col-md-3 col-3 text-right">
              <CButton id="createStockInImportDocButton" class="btn btn-outline-success btn-block" style="display: flex; align-items: center; justify-content: center;" @click="AddPOModal = true">
                <i class="fi fi-rr-plus" style="margin-right: 8px;"></i> {{ $t('นำเข้าจากใบสั่งซื้อสินค้า') }}
              </CButton>
            </div> -->
            <div class="col-md-3 col-3 text-right">
              <CButton id="createStockInImportDocButton" class="btn btn-outline-success btn-block" style="display: flex; align-items: center; justify-content: center;" @click="AddCheckStockModalOpen()">
                <i class="fi fi-rr-plus" style="margin-right: 8px;"></i> {{ $t('importcheckStockDoc') }}
              </CButton>
            </div>
            <div class="col-md-2 col-2 text-right">
              <CButton id="createStockInAddProductButton" class="btn btn-outline-success btn-block" style="display: flex; align-items: center; justify-content: center;" @click="AddModal()">
                <i class="fi fi-rr-plus" style="margin-right: 8px;"></i>{{ $t('addProduct') }}
              </CButton>
            </div>
          </div>
          <div class="mt-3">
            <table id="createStockInTable" style="white-space: nowrap;" v-if="items.length != 0"
              class="table table-sm table-responsive table-bordered mb-4">
              <thead>
                <tr>
                  <th class="text-center text-dark font-weight-normal">#</th>
                  <th></th>
                  <th class="text-dark font-weight-normal">{{ $t('pluCode') }}</th>
                  <th class="text-dark font-weight-normal">{{ $t('productName') }}</th>
                  <th class="text-dark font-weight-normal">{{ $t('unit') }}</th>
                  <th class="text-right text-dark font-weight-normal">{{ $t('quantity') }}</th>
                  <th class="text-right text-dark font-weight-normal">{{ $t('stockUnit') }}</th>
                  <th class="text-right text-dark font-weight-normal">{{ $t('discount') }}</th>
                  <th class="text-right text-dark font-weight-normal">{{ $t('total') }}</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in items" :key="index" :id="'createStockInTableRow' + index">
                  <td :id="'createStockInIndex' + index" style="width: 2%;" class="text-center text-dark font-weight-normal"
                    :value="(item.orderIndex = index)">
                    <div style="margin-top: 6px">
                      {{ index + 1 }}
                    </div>
                  </td>
                  <td :id="'createStockInImageCol' + index" style="width: 5%;">
                    <div v-if="item.remoteImagePath" :style="{
                      'background-image': `url('${item.remoteImagePath}'), url('${noImg}')`,
                      'background-size': 'cover',
                      'background-position': 'center center',
                      'width': 'auto',
                      'border-radius': '2px',
                      'aspect-ratio': '1.3',
                      'min-width': '50px',
                    }"></div>
                    <div :id="'createStockInPlaceholderImage' + index" v-else style="border-radius: 2px" :style="{
                      'aspect-ratio': '4 / 3',
                      'min-width': '50px',
                      backgroundColor: item.indexColor,
                    }"></div>
                  </td>
                  <td :id="'createStockInPLUCodeCol' + index">
                    <div class="text-dark font-weight-normal" style="margin-top: 6px">
                      {{ item.productPLU.PLUCode || '' }}
                    </div>
                  </td>
                  <td style="width: 30%" :id="'createStockInNameCol' + index">
                    <div :id="'createStockInName' + index"
                        class="text-dark font-weight-normal"
                        style="margin-top: 6px">

                      <span v-if="item.vatType === 'N'">
                        {{ item.productPLU.name || '' }}
                        <small v-if="item.docNo" class="text-muted ml-1"> ({{ item.docNo }}) </small>
                        <CBadge color="danger">Non VAT</CBadge>
                      </span>

                      <span v-else>
                        {{ item.productPLU.name || '' }}
                        <small v-if="item.docNo" class="text-muted ml-1"> ({{ item.docNo }}) </small>
                      </span>

                    </div>
                  </td>
                  <td>
                    <div class="text-dark font-weight-normal" style="margin-top: 6px">
                      {{ item.productPLU.unit ? (item.productPLU.unit.name || '-') : '-' }}/{{
                        item.productPLU.SKURatio || '1'
                      }}
                    </div>
                  </td>
                  <td>
                    <input  :id="'createStockInQuantity' + index" style="width: 100%; height: 100%" type="number" min="0" v-model.number="item.quantity"
                      class="form-control form-control-md text-right text-dark font-weight-normal" />
                    <p class="text-dark font-weight-normal" v-if="Number(item.quantity) < 0 ||
                      Number.isNaN(parseInt(item.quantity))
                      ">
                      {{ $t('dialogfound') }}
                    </p>
                  </td>
                  <td>
                    <input :id="'createStockInCost' + index" style="width: 100%; height: 100%" type="number" min="0"
                      class="form-control form-control-md text-right text-dark font-weight-normal"
                      v-model.number="item.cost" />
                  </td>
                  <td>
                    <input :id="'createStockInDiscountItem' + index" style="width: 100%; height: 100%" type="number" min="0"
                      class="form-control form-control-md text-right text-danger font-weight-normal"
                      v-model.number="item.discount" />
                  </td>
                  <td>
                    <input :id="'createStockInGrandTotalItem' + index" style="width: 100%; height: 100%"
                      class="form-control form-control-md text-right text-dark font-weight-normal"
                      :value="grandTotalItem(item)" disabled />
                  </td>
                  <td class="text-center" style="width: 2%">
                    <CButton  :id="'createStockInRemoveItem' + index" color="danger" size="sm" @click="removeProduct(item)">
                      <CIcon name="cil-trash"></CIcon>
                    </CButton>
                  </td>
                </tr>
              </tbody>
            </table>
            <CDataTable v-else  id="createStockInEmptyTable">
              <template #no-items-view>
                <div class="text-center my-5">
                  <h4 style="color: #ced2d8;">
                    {{ $t('noItem') }}
                  </h4>
                </div>
              </template>
            </CDataTable>

            <div v-if="validateItem" class="text-danger">
              {{ validateItem }}
            </div>
            <p class="text-danger" v-if="warning != ''">{{ warning }}</p>
            <p v-if="duplicateItem != ''" class="text-danger">
              {{ duplicateItem }}
            </p>
          </div>
          <div class="row justify-content-between" v-if="items.length != 0">
            <div class="col-2 text-right">
              <p v-if="isAVGCostCalc === false">{{ $t('isAVGCostCalc') }}</p>
              <p v-else-if="isAVGCostCalc === true">
                {{ $t('isAVGCostCalc') }}
              </p>
              <CSwitch v-model="isAVGCostCalc" color="success" :value="isAVGCostCalc" :checked.sync="isAVGCostCalc" />
            </div>
            <div class="col-md-2 col-1 text-right">
              <p v-if="isVatIncluded === false">{{ $t('isVatIncluded') }}</p>
              <p v-else-if="isVatIncluded === true">
                {{ $t('vatIccludes') }}
              </p>
              <CSwitch  id="createStockInIsVatIncludedSwitch" v-model="isVatIncluded" color="success" :value="isVatIncluded" :checked.sync="isVatIncluded" />
            </div>
            <div class="col-md-2 col-6 text-right">
              <p>{{ $t('totalNet') }}</p>
              <h4 id="createStockInNetTotalCurrencyString">{{ netTotalCurrencyString }}</h4>
            </div>
            <div class="col-md-2 col-6 text-right">
              <p>{{ $t('discount') }}</p>
              <input id="createStockInDiscount" style="margin-top: -5px;" v-model="discount"
                class="form-control form-control-md text-right text-danger" />
            </div>
            <div class="col-md-2 col-6 text-right">
              <p>{{ $t('vat') }} 7%</p>
              <h4 id="createStockInVatCurrencyString">{{ vatCurrencyString }}</h4>
            </div>
            <div class="col-md-2 col-6 text-right">
              <p>{{ $t('grandTotal') }}</p>
              <h4 id="createStockInGrandTotal">{{ grandTotal }}</h4>
            </div>
          </div>
        </CCardBody>
      </CCard>
    </CCol>

    <!-- Footer button -->
    <CCol>
      <div class="row justify-content-end mb-4" style="margin: 0">
        <CButton id="createStockInCancel" class="btn col-lg-2 col-4 shadow-sm text-dark font-weight-normal"
          style="margin-right: 15px; background-color: white;" @click="$router.go(-1)">
          {{ $t('cancel') }}
        </CButton>
        <CButton id="createStockInHandlepopup" class="btn btn-success col-lg-2 col-4 font-weight-normal" @click="handlePopup"
          :disabled="items.length === 0">
          {{ $t('save') }}
        </CButton>
      </div>
    </CCol>

    <!-- Confirm modal -->
    <CRow>
      <CModal id="createStockInPopupModal" :show.sync="popupModal" color="success" :title="$t('confirmSaveDoc')" centered :footer="footer">
        <br />
        <h4 class="text-center">{{ $t('confirmSaveDocModal') }}</h4>
        <br />
        <template #footer>
          <CRow class="justify-content-around col-md-12">
            <CCol col="6">
              <CButton id="createStockInCancelButton" block color="light" @click="popupModal = false" class="font-weight-normal">
                {{ $t('cancel') }}
              </CButton>
            </CCol>
            <CCol col="6">
              <CButton id="createStockInSaveButton" block color="success" v-if="loadingButton === true" v-on:click="formSubmit">
                {{ $t('save') }}
              </CButton>
              <CButton id="createStockInSaveDisabledButton" block color="success" v-else-if="loadingButton === false" disabled>
                <CSpinner color="white" size="sm" /> {{ $t('save') }}
              </CButton>
            </CCol>
          </CRow>
        </template>
      </CModal>
    </CRow>

    <!-- Select Product modal -->
    <CRow>
      <CModal id="createStockInAddProductModal" :show.sync="AddProductModal" centered style="max-width: 915px;" :footer="footer" size="lg">
        <template #header-wrapper class="header-modal">
          <header class="modal-header header-modal">
            <h4 class="modal-title font-weight-normal">
              {{ $t('selectdProduct') }}
            </h4>
            <button id="createStockInModalCloseButton" type="button" aria-label="Close" class="close" @click="AddProductModal = false">
              ×
            </button>
          </header>
        </template>
        <template #body-wrapper>
          <CCardBody>
            <CAlert color="danger" :show.sync="isshowAlert" closeButton>
              {{ $t('limitItems') }}
            </CAlert>
            <CRow class="mb-3">
              <label class="col-sm-1  col-form-label text-left text-dark">
                {{ $t('search') }}
              </label>
              <CCol style="padding-right: 0;">
                <select id="createStockInSearchBySelect" v-model="searchBy" class="custom-select no-border-radius-left">
                  <option value="PLUCode">{{ $t('pluCode') }}</option>
                  <option value="name">{{ $t('productName') }}</option>
                  <option value="category">{{ $t('category') }}</option>
                </select>
              </CCol>
              <CCol class="pl-0 col-6">
            <template v-if="searchBy === 'category'">
              <select id="createStockInCategorySelect" v-model="selectedCategory" class="form-control text-dark no-border-radius-right" >
                <option selected disabled value="">{{ $t('selectCategory') }}</option>
                <option :id="'createStockInCategoryOption' + index" v-for="(category, index) in dataCategory" :key="category.objectId" :value="category.objectId">
                  {{ category.name }}
                </option>
              </select>
            </template>
            <template v-else>
              <input id="createStockInSearchInput" class="form-control text-dark no-border-radius-right" v-model="keywordEntered" @keyup.enter="searchProductPLU"
                :placeholder="$t('searchProduct')" />
            </template>
          </CCol>
              <CCol class="p-0">
                <CButton id="createStockInSearchButton" block color="success" v-if="loadingButton === true" v-on:click="searchProductPLU">
                  {{ $t('search') }}
                </CButton>
              </CCol>
              <CCol class="pl-1">
                <CButton id="createStockInResetButton" class="btn btn-outline-secondary text-dark font-weight-normal"
                  style="color: black; width: inherit" v-on:click="reset">
                  {{ $t('reset') }}
                </CButton>
              </CCol>
            </CRow>
            <div v-if="checkAllAlert" class="alert alert-warning  mt-2 mb-0" style="font-size: 13px;">
              <i class="fi fi-rr-info mr-1"></i> การเลือกทั้งหมด จะเลือกเฉพาะสินค้าในหน้านี้เท่านั้น หากต้องการเลือกสินค้าเพิ่ม กรุณาเปลี่ยนหน้าแล้วเลือกเพิ่มเติม
            </div>
            <div style="max-height: 400px; overflow-y: auto;" class="text-dark">
              <CDataTable id="createStockInDataTable"  class="text-dark" :fields="fields" :items="autoCompleteResult" hover v-model="autoCompleteResult" border
                clickableRows @row-clicked="onSelectedAutoCompleteEvent">
                <template slot="selected-header">
                  <div class="custom-control custom-checkbox text-dark" style="padding-left: 2rem">
                    <input v-model="all" type="checkbox" @change="setAll()" class="custom-control-input success cursor"
                      id="yyy" />
                    <label class="custom-control-label cursor" for="yyy">
                    </label>
                  </div>
                </template>
                <template #selected="{ item, index }">
                  <td :id="'createStockInSelectedCell' + index" style="vertical-align: middle;">
                    <div class="custom-control custom-checkbox text-dark" style="padding-left: 2rem">
                      <input type="checkbox" class="custom-control-input success cursor" :disabled="item.inDocument" v-model="item.selected"
                        @change="onSelectedAutoCompleteEvent(item)" :id="index" />
                      <label class="custom-control-label cursor" :for="index">
                      </label>
                    </div>
                  </td>
                </template>
                <template #name="{ item, index }">
                  <td style="vertical-align: middle;border-left: hidden;" :for="index">
                    <img v-if="item.remoteImagePath" :src="item.remoteImagePath"
                      style="border-radius: 2px;aspect-ratio: 4 / 3;" class="img-fluid" @error="noImgUrl" />
                    <div v-else style="border-radius: 2px" :style="{
                      'aspect-ratio': '4 / 3',
                      backgroundColor: item.indexColor,
                    }"></div>
                  </td>
                </template>
                <template #nameproduct="{ item }">
                  <td class="text-dark font-weight-normal" style="vertical-align: middle;border-left: hidden;">
                    {{ item.name }}
                  </td>
                </template>
                <template #categoryName="{ item }">
                  <td class="text-dark font-weight-normal" style="vertical-align: middle;border-left: hidden;">
                    {{ item.categoryName }}
                  </td>
                </template>
                <template #pluCode="{ item }">
                  <td class="text-dark font-weight-normal" style="vertical-align: middle;border-left: hidden;">
                    {{ item.PLUCode }}
                  </td>
                </template>
                <template #price="{ item, index }">
                  <td class="text-dark font-weight-normal" :for="index"
                    style="vertical-align: middle;border-left: hidden " v-if="item.ProductSKU.stdCost === '' ||
                      item.ProductSKU.stdCost === undefined
                      ">
                    ฿ 0
                  </td>
                  <td class="text-dark font-weight-normal" :for="index"
                    style="vertical-align: middle;border-left: hidden " v-else>
                    ฿ {{ item.ProductSKU.stdCost }}
                  </td>
                </template>
                <template #onhanQTY="{ item, index }">
                  <td
                    class="text-right"
                    :for="index"
                    style="vertical-align: middle; border-left: hidden"
                    v-if="
                    item.ProductPLUStock.onhandQty === '' ||
                    item.ProductPLUStock.onhandQty === undefined
                  "
                >
                  N/A
                </td>
                <td
                  class="text-right"
                  :for="index"
                  style="vertical-align: middle; border-left: hidden"
                  v-else
                >
                  <div
                    v-if="item.ProductPLUStock.onhandQty < 0 && Number.isInteger(parseFloat(item.ProductPLUStock.onhandQty))"
                    class="text-danger"
                  >
                    {{ parseFloat(item.ProductPLUStock.onhandQty) }}
                  </div>
                  <div
                    v-else-if="item.ProductPLUStock.onhandQty < 0 && !Number.isInteger(parseFloat(item.ProductPLUStock.onhandQty))"
                    class="text-danger"
                  >
                    {{ parseFloat(item.ProductPLUStock.onhandQty).toFixed(3) }}
                  </div>
                  <div
                    v-else-if="!Number.isInteger(parseFloat(item.ProductPLUStock.onhandQty))"
                    class="text-dark"
                  >
                    {{ parseFloat(item.ProductPLUStock.onhandQty).toFixed(3) }}
                  </div>
                  <div v-else class="text-dark">
                    {{ parseFloat(item.ProductPLUStock.onhandQty) }}
                  </div>
                </td>
              </template>
                <template #no-items-view>
                  <div class="text-center my-5">
                    <h4 style="color: #ced2d8;">
                      {{ $t('noItem') }}
                    </h4>
                  </div>
                </template>
              </CDataTable>
            </div>
            <pagination :meta_data="meta_data_product" v-on:next="searchProductPLU">
            </pagination>
          </CCardBody>
        </template>
        <template #footer-wrapper>
          <CRow class="justify-content-end col-md-12">
            <CCol col="12" lg="6" class="row">
              <div class="col-6">
                <CButton id="createStockInCancelButton" class="btn btn-outline-secondary text-dark font-weight-normal"
                  style="color: black; width: inherit" @click="AddProductModal = false">
                  {{ $t('cancel') }}
                </CButton>
              </div>
              <div class="col-6">
                <CButton id="createStockInConfirmButton" block color="success" v-if="loadingButton === true" v-on:click="onCheckboxChange">
                  {{ $t('confirm') }}
                </CButton>
                <CButton id="createStockInConfirmDisabledButton" block color="success" v-else-if="loadingButton === false" disabled>
                  <CSpinner color="white" size="sm" /> {{ $t('save') }}
                </CButton>
              </div>
            </CCol>
          </CRow>
          <br />
        </template>
      </CModal>
    </CRow>
    <CRow>
      <CModal id="createStockInModal" :show.sync="AddCheckStockModal" centered :footer="footer" size="lg" style="max-width: 915px;">
        <template #header-wrapper class="header-modal">
          <header class="modal-header header-modal">
            <h4 class="modal-title font-weight-normal">
              {{ $t('selectCheckStockDoc') }}
            </h4>
            <CButton id="createStockInCreateCheckStockButton" to="/inventory/check-stock/create" color="warning">
              <i class="fi fi-rr-plus" style="margin-right: 8px;"></i>  {{ $t('createCheckStock') }}
            </CButton>
            <!-- <button type="button" aria-label="Close" class="close" @click="AddCheckStockModal = false">
              ×
            </button> -->
          </header>
        </template>
        <template #body-wrapper>
          <CCardBody>
            <CRow class="mb-3">
              <label class="col-sm-1  col-form-label text-left text-dark">
                {{ $t('search') }}
              </label>
              <CCol style="padding-right: 0;">
                <select id="createStockInSearchBySelect" v-model="searchDocBy" class="custom-select no-border-radius-left">
                  <option value="note">{{ $t('checkStockName') }}</option>
                  <option value="checkStockNo">{{ $t('documentNo') }}</option>
                  <!-- <option value="created_at">{{ $t('category') }}</option> -->
                </select>
              </CCol>
              <CCol class="pl-0 col-6">
                <template >
                  <input id="createStockInSearchInput" class="form-control text-dark no-border-radius-right" v-model="keywordDocEntered" @keyup.enter="getCheckStock(1)"
                    :placeholder="$t('searchProduct')" />
                </template>
              </CCol>
              <CCol class="p-0">
                <CButton id="createStockInSearchButton" block color="success" v-if="loadingButton === true" v-on:click="getCheckStock(1)">
                  {{ $t('search') }}
                </CButton>
              </CCol>
              <CCol class="pl-1">
                <CButton id="createStockInResetButton" class="btn btn-outline-secondary text-dark font-weight-normal"
                  style="color: black; width: inherit" v-on:click="resetDoc">
                  {{ $t('reset') }}
                </CButton>
              </CCol>
            </CRow>
            <div style="max-height: 400px; overflow-y: auto;">
              <CDataTable id="createStockInDataTable" :fields="checkStockFields" :items="checkStockItem" hover border v-model="checkStockItem"
                clickableRows @row-clicked="onSelectCheckStockDoc">

                <!-- <template slot="selected-header">
                  <div class="custom-control custom-checkbox" style="padding-left: 2rem">
                    <input v-model="all" type="checkbox" @change="setAll()" class="custom-control-input success cursor"
                      id="checkbox" />
                    <label class="custom-control-label cursor" for="checkbox">
                    </label>
                  </div>
                </template> -->
                <template slot="nameproduct-header">
                  <p></p>
                </template>
                <template #selected="{ item, index }">
                  <td :id="'createStockInSelectedCell' + index" style="vertical-align: middle; text-align: center;">
                    <div class="custom-control custom-checkbox " style="padding-left: 2rem">
                      <input type="checkbox" class="custom-control-input success cursor" v-model="item.selected"
                        @change="onSelectCheckStockDoc(item)" :id="index" />
                      <label class="custom-control-label cursor" :for="index">
                      </label>
                    </div>
                  </td>
                </template>
                <template #name="{ item }">
                  <td class="text-dark" style="vertical-align: middle;">
                    {{ item.note }}
                  </td>
                </template>
                <template #no-items-view>
                  <div class="text-center my-5">
                    <h4 style="color: #ced2d8;">
                      {{ $t('noItem') }}
                    </h4>
                  </div>
                </template>
              </CDataTable>

            </div>
            <pagination :meta_data="meta_data" v-on:next="getCheckStock">
            </pagination>
          </CCardBody>
        </template>
        <template #footer-wrapper>
          <CRow class="justify-content-end col-md-12">
            <CCol col="12" lg="6" class="row">
              <div class="col-6">
                <CButton id="createStockInCancelButton" class="btn btn-outline-secondary text-dark font-weight-normal" style="width: inherit"
                  @click="AddCheckStockModal = false">
                  {{ $t('cancel') }}
                </CButton>
              </div>
              <div class="col-6">
                <CButton id="createStockInConfirmButton" block color="success" v-if="loadingButton === true" v-on:click="onCheckboxChange">
                  {{ $t('confirm') }}
                </CButton>
                <CButton id="createStockInSaveDisabledButton" block color="success" v-else-if="loadingButton === false" disabled>
                  <CSpinner color="white" size="sm" /> {{ $t('save') }}
                </CButton>
              </div>
            </CCol>
          </CRow>
          <br />
        </template>
      </CModal>
    </CRow>
    <CRow>
      <CModal id="createStockInSelectPOModal" :show.sync="AddPOModal" centered :footer="footer" size="lg" style="max-width: 915px;">
        <template #header-wrapper class="header-modal">
          <header class="modal-header header-modal">
            <h4 class="modal-title font-weight-normal">
              {{ $t('selectPO') }}
            </h4>
            <!-- <CButton id="createStockInCreateCheckStockButton" to="/inventory/check-stock/create" color="warning">
              <i class="fi fi-rr-plus" style="margin-right: 8px;"></i>  {{ $t('createCheckStock') }}
            </CButton> -->
            <!-- <button type="button" aria-label="Close" class="close" @click="AddCheckStockModal = false">
              ×
            </button> -->
          </header>
        </template>
        <template #body-wrapper>
          <CCardBody>
            <div style="max-height: 400px; overflow-y: auto;">
              <CDataTable
              :key="componentIndex"
              id="createAdjustStockDataTable"
              :fields="prdocFields"
              :items="processedDocuments"
              hover
              border
              v-model="prDocItem"
              @row-clicked="selectPO"
            >
              <template slot="nameproduct-header">
                <p></p>
              </template>
              <template #selected="{ item, index }">
                <td
                  :id="'createAdjustStockSelectedRow' + index"
                  style="vertical-align: middle; text-align: center"
                >
                  <div class="custom-control custom-checkbox" style="padding-left: 2rem">
                    <input
                      type="checkbox"
                      class="custom-control-input success cursor"
                      v-model="item.selected"
                      @change="selectPO(items)"
                      :id="index"
                    />
                    <label class="custom-control-label cursor" :for="index"> </label>
                  </div>
                </td>
              </template>
              <template #name="{ item }">
                <td class="text-dark" style="vertical-align: middle; border-left: hidden">
                  {{ item.docNo }}
                </td>
              </template>
              <template #status="{ item }">
              <td>
              <CBadge :class="getStatusColor(item.status)"> {{ item.status }}
              </CBadge>
              </td>
              </template>
              <template #no-items-view>
                <div class="text-center my-5">
                  <h4 style="color: #ced2d8">
                    {{ $t("noItem") }}
                  </h4>
                </div>
              </template>
            </CDataTable>
            </div>
          </CCardBody>
        </template>
        <template #footer-wrapper>
          <CRow class="justify-content-end col-md-12">
            <CCol col="12" lg="6" class="row">
              <div class="col-6">
                <CButton id="createStockInCancelButton" class="btn btn-light text-dark font-weight-normal" style="width: inherit"
                  @click="AddPOModal = false">
                  {{ $t('cancel') }}
                </CButton>
              </div>
              <div class="col-6">
                <CButton id="createStockInConfirmButton" block color="success" v-if="loadingButton === true" v-on:click="onCheckboxChange">
                  {{ $t('confirm') }}
                </CButton>
                <CButton id="createStockInSaveDisabledButton" block color="success" v-else-if="loadingButton === false" disabled>
                  <CSpinner color="white" size="sm" /> {{ $t('save') }}
                </CButton>
              </div>
              
            </CCol>
          </CRow>
          <br />
        </template>
      </CModal>
    </CRow>
    <CModal :show.sync="modalSavePO" centered color="success" :title="$t('confirmSaveDoc')" :footer="footer">
      <h4 v-if="showSaveContinue" class="text-center m-4" v-html="$t('confirmSaveContinue')"></h4>
      <h4 v-if="showSaveCompleted" class="text-center m-4" v-html="$t('confirmSaveDocModal')"></h4>
      <template #footer>
        <CRow class="justify-content-center col-md-12">
          <CCol col="6" v-if="showSaveCompleted">
            <CButton block color="light" @click="modalSavePO = false">
              {{ $t('cancel') }}
            </CButton>
          </CCol>
          <CCol col="6" v-if="showSaveContinue">
            <CButton block color="warning" @click="saveContinue">
              {{ $t('saveContinue') }}
            </CButton>
          </CCol>
          <CCol col="6" >
            <CButton block color="success" @click="saveCompleted">
              {{ $t('saveConfirm') }}
            </CButton>
          </CCol>
        </CRow>
      </template>
    </CModal>
  </div>
  <div v-else>
    <access-data></access-data>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
import axios from '@/services/local'
import util from '@/util/util'
import Multiselect from 'vue-multiselect'
import permis from '@/util/permission'
import pos from '@/services/local'
import Pagination from '@/containers/Pagination'
// import VueDatePicker from 'vue2-datepicker'
// import 'vue2-datepicker/index.css'

export default {
  components: {
    Multiselect,
    Pagination,
    // VueDatePicker
  },
  data() {
    return {
      checkAllAlert: false,
      meta_data_product: {
        last_page: null,
        current_page: 1,
        items: 0,
        limit: 20,
        itemCount: null,
      },
      isSuccess: false,
      alert: false,
      data: [],
      datetime: new Date(),
      shop: this.$store.getters.shopObjectId,
      member: null,
      members: [],
      isVatIncluded: false,
      isAVGCostCalc: false,
      billNo: '',
      note: '',
      discount: '0',
      searchBy: 'name',
      label: 'name',
      keyword: '',
      placeHolderInputText: 'พิมพ์ชื่อสินค้าที่ต้องการค้นหา .​.​.',
      autoCompleteResult: [],
      autoCompleteProgress: false,
      autoCompleteText: 'name',
      autoCompleteText2: 'PLUCode',
      autoCompleteText3: 'unitName',
      autoCompleteFieldId: 'alpha3Code',
      items: [],
      vatType: '',
      // itemList: [],
      validateShop: '',
      validateItem: '',
      popupModal: false,
      footer: '',
      loadingButton: true,
      duplicateItem: '',
      warning: '',
      permission: false,
      AddProductModal: false,
      AddCheckStockModal: false,
      keywordEntered: '',
      selectedItems: [],
      all: false,
      isshowAlert: 0,
      checkStockItem: [],
      dataCategory: [],
      selectedCategory: '',
      componentIndex: 0,
      AddPOModal: false,
      prDocItem: [],
      documents:[],
      refDocPO: null,
      refDocCreateAt: null,
      popupModal: false,
    modalSavePO: false,
    showSaveCompleted: false,
    showSaveContinue: false,
    meta_data: {
        last_page: null,
        current_page: 1,
        prev_page_url: null,
        items: 0,
        limit: null,
        itemCount: null,
    },
    meta_data_processedDocuments: {
        last_page: null,
        current_page: 1,
        prev_page_url: null,
        items: 0,
        limit: null,
        itemCount: null
    },
    searchDocBy : 'note',
    keywordDocEntered :''
  }
  },
  computed: {
    ...mapGetters(['shops', 'users', 'date', 'access', 'permissions']),
    uid() {
      return `${localStorage.getItem('shopsUid')}`
    },
    isPermission() {
      let path = '/inventory/stock-in'
      return permis.findPermissionRead('inventory', path)
    },
    isEditData() {
      let path = '/inventory/stock-in'
      return permis.findPermissionEdit('inventory', path)
    },
    shopObjectId: {
      get() {
        return this.$store.getters.shopObjectId
      },
      set(newValue) {
        return this.$store.dispatch('setShop', newValue)
      },
    },
    startDate() {
      return moment(String(this.date.start)).format('DD MMMM YYYY')
    },
    shopOptions() {
      let detail = []
      this.shops.forEach((shop) => {
        detail.push({
          value: shop,
          label: shop.shopName + ' - ' + shop.branchName,
        })
      })
      return detail
    },
    memberOptions() {
      let detail = []
      this.members.forEach((member) => {
        detail.push({
          value: member,
          label: member.name,
        })
      })
      return detail
    },
    vat() {
      let vat = 0;
      this.items.forEach(item => {
        vat += this.calculateVat(item);
      });

      return vat;
    },
    vatCurrencyString() {
      return util.convertCurrency(this.vat);
    },
    grandTotal() {
      let grandTotal = ''
      let summary = this.netTotal || 0
      let vat = this.vat || 0

      if (this.isVatIncluded === false) {
        grandTotal = summary - this.discount
      } else if (this.isVatIncluded === true) {
        grandTotal = summary + vat - this.discount
      }

      return util.convertCurrency(grandTotal)
    },
    netTotal() {
      let total = 0;
      this.items.forEach(item => {
        total += this.grandTotalItem(item);
      });
      return total;
    },
    netTotalCurrencyString() {
      return util.convertCurrency(this.netTotal)
    },
    noImg() {
      return process.env.VUE_APP_NOIMAGE
    },
    fields() {
      return [
        {
          key: 'selected',
          label: this.$i18n.t('selectd'),
          _style: 'width:5%; vertical-align: middle; text-dark',
          _classes: 'text-left font-weight-normal text-dark',
        },
        {
          key: 'name',
          label: '',
          _style: 'width:7%; vertical-align: middle;border-left: hidden text-dark',
          _classes: 'text-left font-weight-normal text-dark',
        },
        {
          key: 'nameproduct',
          label: this.$i18n.t('product'),
          _style: 'width:30%; vertical-align: middle;border-left: hidden text-dark',
          _classes: 'text-left font-weight-normal text-dark',
        },
        {
          key: 'pluCode',
          label: this.$i18n.t('pluCode'),
          _style: 'width:25%; vertical-align: middle;border-left: hidden text-dark',
          _classes: 'text-left font-weight-normal text-dark',
        },
        {
          key: 'categoryName',
          label: this.$i18n.t('category'),
          _style: 'width:23%; vertical-align: middle;  text-dark',
          _classes: 'text-left font-weight-normal text-dark',
        },
        {
          key: 'onhanQTY',
          label: this.$i18n.t('onhandQty'),
          _classes: 'text-right font-weight-normal text-dark',
          _style: 'width:30%; vertical-align: middle;border-left: hidden text-dark',
        },
      ]
    },
    memberslist() {
      const member = this.members || []
      let detail = []
      for (let i = 0; i < member.length; i++) {
        const item = member[i]
        const fullName = (item.firstname || item.name || '') + ' ' + (item.lastname || '')
        detail.push({
          id: item.id,
          objectId: item.objectId,
          name: fullName,
        })
      }
      return detail
    },
    checkStockFields() {
      return [
        {
          key: 'selected',
          label: this.$i18n.t('selectd'),
          _style: 'width:10%; vertical-align: middle;',
          _classes: 'text-center text-dark font-weight-normal',
        },
        {
          key: 'createdDate',
          label: this.$t('createdAt'),
          _style: 'width:20%; vertical-align: middle;',
          _classes: 'font-weight-normal text-dark',
        },
        {
          key: 'checkStockNo',
          label: this.$t('documentNo'),
          _style: 'width:20%; vertical-align: middle;',
          _classes: 'font-weight-normal text-dark',
        },
        {
          key: 'name',
          label: this.$i18n.t('checkStockName'),
          _style: 'width:40%; vertical-align: middle;',
          _classes: 'text-left text-dark font-weight-normal',
        },
        {
          key: 'createdBy',
          label: this.$t('saveBy'),
          _style: 'width:30%; vertical-align: middle;',
          _classes: 'font-weight-normal text-dark',
        }
      ]
    },
    prdocFields() {
      return [
        {
          key: "selected",
          label: this.$i18n.t("selectd"),
          _style: "width:5%; vertical-align: middle;",
          _classes: "text-center text-dark font-weight-normal",
        },
        // {
        //   key: "createdDate",
        //   label: this.$t('createdAt'),
        //   _style: "width:20%",
        //   _classes: "font-weight-normal text-dark",
        // },
        {
          key: "docNo",
          label: this.$t('documentNo'),
          _style: "width:15%",
          _classes: "font-weight-normal text-dark",
        },
        {
          key: "supplier",
          label: this.$t('supplier'),
          _style: "width:20%",
          _classes: "font-weight-normal text-dark",
        },
        {
          key: "dueDate",
          label: this.$t('dueDate'),
          _style: "width:15%",
          _classes: "font-weight-normal text-dark",
        },
        {
          key: "createdBy",
          label: this.$t('createBy'),
          _style: "width:10%",
          _classes: "font-weight-normal text-dark",
        },
        {
          key: "status",
          label: this.$t('status'),
          _style: "width:10%",
          _classes: "font-weight-normal text-dark",
        },
      ];
    },
    processedDocuments() {
      let data = this.documents || [];
      let detail = [];
      for (let i = 0; i < this.documents.length; i++) {
        let item = data[i];
        const docNo = item.docNo || "-";
        const createdBy = item.createdBy || "-";

        const createdDate = item.created_at
          // moment(String(item.created_at)).format("DD/MM/YYYY HH:mm:ss") || "-";
        const supplier = item.supplier?.name || "-";
        const checkStockName = item.note || "-";
        const status = item.status || "Pending";
        const dueDate = moment(String(item.dueDate)).format("DD/MM/YYYY") || "-";
        const processedItems = item.items
          ? item.items.map((items) => ({
              ...items,
              selected: false,
            }))
          : [];
        detail.push({
          docNo: docNo,
          createdDate: createdDate,
          checkStockName: checkStockName,
          supplier: supplier,
          createdBy: createdBy,
          status: status,
          dueDate: dueDate,
          objectId: item.objectId || "-",
          id: item.id,
          items: processedItems,
          selected: false,
        });
      }
      return detail;
    },
  },
  created() {
    this.getMember()
    this.getCategory()
    this.shop = this.shops.find((i) => i.objectId === this.shop)
    // this.fetchDocuments()
  },
  methods: {
    ...util,
    AddModal() {
      this.keywordEntered = ''
      this.autoCompleteResult = []
      this.all = false
      this.searchProductPLU()
      this.AddProductModal = true
    },
    AddCheckStockModalOpen() {
      this.getCheckStock()
      this.AddCheckStockModal = true
    },
     resetDoc(){
      this.selectedItems = []
      this.searchDocBy = 'note'
      this.keywordDocEntered = ''
      this.getCheckStock(1)
    },
    formatDate(date) {
      if (!date) return ''

      // ถ้าเป็น string (จาก date-picker)
      if (typeof date === 'string') {

        // ถ้า locale = en (ค่าจะมาเป็น MM/DD/YYYY)
        if (this.$i18n.locale === 'en') {
          return moment(date, 'MM/DD/YYYY').format('DD/MM/YYYY')
        }

        // ถ้า locale = th (ค่าจะมาเป็น DD/MM/YYYY อยู่แล้ว)
        if (this.$i18n.locale === 'th') {
          return moment(date, 'DD/MM/YYYY').format('DD/MM/YYYY')
        }

        // fallback
        return moment(date).format('DD/MM/YYYY')
      }

      // ถ้าเป็น Date object (ดีที่สุด)
      return moment(date).format('DD/MM/YYYY')
    },
    getCategory() {
      const uid = `${localStorage.getItem('shopsUid')}`;
      const shopObjectId = this.shopObjectId;
      let params = {
        page: 1,
        limit: 1000,
      };
      const headers = {
          shopObjectId: util.sanitizeShopObjectId(shopObjectId),
      }

      pos
        .get('/api/v1.0/shop/' + uid + '/Category/data/' + shopObjectId, {
          params,headers
        })
        .then((res) => {
          let detail = []
          let data = res.data.data
          for (let i = 0; i < data.length; i++) {
            if (data[i].enabled === true) {
              detail.push({
                id: data[i].id,
                name: data[i].name,
                objectId: data[i].objectId,
              })
            }
          }
          this.dataCategory = detail
          })
        .catch((error) => {
          console.error("Error fetching categories:", error);
        });
    },
    getCheckStock(page = 1) {
      this.loadingButton = false
      const uid = this.uid
      const shopObjectId = this.shopObjectId
      // const startAt = moment(String(this.date.start)).format('YYYY-MM-DD')
      // const endAt = moment(String(this.date.end)).format('YYYY-MM-DD')

      const params = {
        shopObjectId: shopObjectId,
        page: page,
        limit: 50,

      }
      if (this.keywordDocEntered) {
        params.searchAttr = this.searchDocBy
        params.searchVal = this.keywordDocEntered
      }
      const headers = {
        shopObjectId: util.sanitizeShopObjectId(shopObjectId),
      }
      axios({
        url: '/api/v3.0/checkstockdocument',
        params: params,
        headers: headers,
        method: 'GET',
      })
        .then((res) => {
          this.data = res.data.data
          const paginateData = res.data.paginate || {}
          this.meta_data.items = paginateData.items || 0
          this.meta_data.last_page = paginateData.pageCount || 0
          this.meta_data.current_page = paginateData.currentPage || 0
          this.meta_data.itemCount = paginateData.itemCount || 0
          this.meta_data.limit = paginateData.perPage || 50
          this.data = this.data.filter(item => item.shop.objectId === this.shopObjectId);
          this.loadingButton = true
          const selectedMap = new Set()

          let checkStockDoc = this.data.map(item => {

          if (item.items) {
            item.items = item.items.map(docItem => {
              const objectId = docItem.productPLU?.objectId

              return {
                ...docItem,
                selected: selectedMap.has(objectId) // ✅ restore item
              }
            })
          }

          const isSelected = item.items?.some(docItem =>
            selectedMap.has(docItem.productPLU?.objectId)
          )

          return {
            ...item,
            createdDate: moment(String(item.created_at)).format('DD/MM/YYYY HH:mm'),
            createdBy: item.created_by.username || '-',
            selected: isSelected
          }
        })
          this.checkStockItem = checkStockDoc
        })
        .catch((error) => {
          console.log(error)
        })
    },
    onSelectCheckStockDoc(item) {
      item.selected = !item.selected

      if (!item.items) return

      let selectedDoc = item.items.map(docItem => {
        let newItem = {
          docRef: item.objectId,
          docNo: item.checkStockNo || '',
          PLUCode: docItem.productPLU?.PLUCode || '-',
          name: docItem.productPLU?.name || '-',
          ProductPLU: docItem.productPLU || {},
          ProductSKU: docItem.productSKU || {},
          id: docItem.productPLUId || '',
          objectId: docItem.productPLU?.objectId || '',
          unit: docItem.productPLU?.unit || {},
          unitName: docItem.productPLU?.unit?.name !== undefined 
            ? docItem.productPLU.unit.name 
            : (docItem.unit?.name !== undefined ? docItem.unit.name : '-'),
          ProductPLUStock: docItem.ProductPLUStock || {},
          SKURatio: docItem.productPLU?.SKURatio || 1,
          checkCount: docItem.quantity || 0,
          shop: docItem.shop || {},
          uid: this.uid || '',
          vatType: docItem.productSKU?.vatType || 'V',
          selected: item.selected,
        }

        const matched = this.autoCompleteResult.find(
          x => x.objectId === docItem.productPLU?.objectId
        )

        newItem.ProductSKU.stdCost =
          matched?.stdCost || matched?.ProductSKU?.stdCost || 0

        return newItem
      })

      // ✅ กรณี "เลือก"
      if (item.selected) {
      selectedDoc.forEach(newItem => {
        const exists = this.selectedItems.some(
          x =>
            x.objectId === newItem.objectId &&
            x.docRef === newItem.docRef // 🔥 ต้องเทียบคู่
        )

        if (!exists) {
          this.selectedItems.push(newItem)
        }
      })
    }

      // ❌ กรณี "ยกเลิก"
      else {
        const currentDocRef =  item.objectId

      this.selectedItems = this.selectedItems.filter(
        x => x.docRef !== currentDocRef
      )
      }
    },
    getDateLocale() {
        return this.$i18n.locale
    },
    noImgUrl(event) {
      event.target.src = process.env.VUE_APP_NOIMAGE
    },
    reset() {
      this.selectedItems = []
      this.all = false
      this.keywordEntered = ''
      this.searchBy = 'name'
      this.selectedCategory = ''
      this.searchProductPLU()
    },
    handlePopup() {
      if (this.shopObjectId === '') {
        this.popupModal = false;
        this.validateShop = this.$i18n.t('selectShopPlease');
        return;
      } else {
        this.validateShop = '';
      }

      if (this.items.length === 0) {
        this.popupModal = false;
        this.validateItem = this.$i18n.t('selectProductPlease');
        return;
      } else {
        this.validateItem = '';
      }

      if (!this.refDocPO) {
        this.popupModal = true;
        return;
      }

      const selectedDoc = this.processedDocuments.find(doc => doc.docNo === this.refDocPO);
      
      if (!selectedDoc) {
        this.popupModal = true; 
        return;
      }

      const isAllPoItemsExist = selectedDoc.items.every(poItem => 
        this.items.some(item => item.productPLU?.objectId === poItem.productPLU?.objectId)
      );

      const extraItems = this.items.filter(item => 
        !selectedDoc.items.some(poItem => poItem.productPLU?.objectId === item.productPLU?.objectId)
      );

      const hasExtraItems = extraItems.length > 0;

      this.modalSavePO = true;

      if (isAllPoItemsExist) {
        this.showSaveCompleted = true;
        this.showSaveContinue = false;
      } else {
        this.showSaveCompleted = false;
        this.showSaveContinue = true;
      }
    },
    removeProduct(i) {
      let items = this.items
      let newItems = items.filter((item) => item.orderIndex != i.orderIndex)
      this.items = newItems
      let index = this.autoCompleteResult.findIndex(
        (x) => x.objectId == i.productPLU.objectId
      )
      if (index != -1) {
        this.autoCompleteResult[index].selected = false
      }

      let find = this.selectedItems.findIndex(
        (x) => x.objectId === i.productPLU.objectId
      )
      if (find != -1) {
        this.selectedItems.splice(i, 1)
      }
    },
    totalQuantity(item) {
      let totalQty = 0;

      for (const item of this.items) {
        totalQty += item.quantity;
      }
      return totalQty;
    },
    calculateDiscount(item) {
      const totalQty = this.totalQuantity();
      let discountPerQty = 0;
      if (totalQty !== 0) {
        discountPerQty = this.discount / totalQty;
      } else {
        discountPerQty = 0;
      }

      return discountPerQty
    },
    grandTotalItem(item) {
      let total = 0
      if (item.vatType === 'N') {
        total = item.quantity * item.cost - item.discount
      }
      if (item.vatType === 'V') {
        total = item.quantity * item.cost - item.discount
      } else {
        total = (item.quantity * item.cost) - item.discount;
      }
      return item.total = total
    },
    grandTotalItemDisperQty(item) {
      let totalnonvat = 0;
      let totalincvat = 0;
      let discountPerQty = this.calculateDiscount();
      if (item && item.vatType === 'N') {
        totalnonvat = item.quantity * item.cost - item.discount - (item.quantity * discountPerQty);
        item.total = totalnonvat;
        return totalnonvat
      } else if (item && item.vatType === 'V') {
        totalincvat = item.quantity * item.cost - item.discount - (item.quantity * discountPerQty);
        item.total = totalincvat;
        return totalincvat
      }
      const total = totalnonvat + totalincvat;
    },
    calculateVat(item) {
      let vat = 0;

      if (item.vatType === 'V' && this.isVatIncluded === false) {
        vat = (this.grandTotalItemDisperQty(item) * 7) / 107;
      }
      else if (item.vatType === 'V' && this.isVatIncluded === true) {
        vat = this.grandTotalItemDisperQty(item) * (7 / 100);
      }
      return vat;
    },
    getMember() {
      const uid = this.uid
      const shopObjectId = this.shopObjectId

      const params = {
        shopObjectId: shopObjectId,
      }
      const headers = {
        shopObjectId: util.sanitizeShopObjectId(shopObjectId),
      }
      axios({
        url: '/api/v1.0/' + uid + '/getmember',
        params: params,
        headers: headers,
        method: 'GET',
      })
        .then((res) => {
          this.members = res.data.data.documents
        })
        .catch((error) => {
          console.log(error)
        })
    },
    onSelectedAutoCompleteEvent(item) {
      if (item.inDocument) return
      let cont = 0
      this.autoCompleteResult.forEach(function (item) {
        if (item.selected) {
          cont = cont + 1
        }
      })
      if (cont < 200) {
        item.selected = !item.selected
        if (item.selected) {
          this.selectedItems.push(item)
        } else {
          let i = this.selectedItems.findIndex(
            (x) => x.objectId === item.objectId
          )
          if (i != -1) {
            this.selectedItems.splice(i, 1)
          }
        }
        let countItem = this.autoCompleteResult.length
        let coutselect = 0
        this.autoCompleteResult.forEach((item) => {
          if (item.selected) {
            coutselect = coutselect + 1
          }
        })
        if (countItem === coutselect) {
          this.all = true
        } else {
          this.all = false
        }
      } else {
        this.isshowAlert = 5
      }
    },
    searchProductPLU(page) {
      if (this.shopObjectId === '') {
        this.validateShop = this.$i18n.t('selectShopPlease')
      } else {
        this.validateShop = ''
      }

      const uid = `${localStorage.getItem('shopsUid')}`
      let params = {}
      if (this.searchBy === 'category' && this.selectedCategory) {
        params = {
          shopObjectId: this.$store.getters.shopObjectId,
          categoryObjectId: this.selectedCategory,
          page: page || 1,
          limit: 50,
        }
      } else if (this.keywordEntered != '') {
        params = {
          shopObjectId: this.$store.getters.shopObjectId,
          searchBy: this.searchBy,
          keyword: this.keywordEntered,
          page: page || 1,
          limit: 50,
        }
      } else {
        params = {
          shopObjectId: this.$store.getters.shopObjectId,
          searchBy: this.searchBy,
          page: page || 1,
          limit: 50,
        }
      }
      this.label = this.searchBy
      let selectedItems = this.selectedItems
      // if (keywordEntered.length > 0) {
      const headers = { shopObjectId: util.sanitizeShopObjectId(this.$store.getters.shopObjectId) }
      axios({
        url: '/api/v1.0/' + uid + '/getproductpluwithstock/paginate',
        params: params,
        headers: headers,
        method: 'GET',
      })
        .then((response) => {
          this.alert = false
          const paginate = response.data.paginate || {}
          this.meta_data_product.items = paginate.items || 0
          this.meta_data_product.last_page = paginate.pageCount || 0
          this.meta_data_product.current_page = paginate.currentPage || 0
          this.meta_data_product.itemCount = paginate.itemCount || 0
          this.meta_data_product.limit = paginate.perPage || 20
          let newData = []
          response.data.data.forEach((item) => {
            if (selectedItems.length > 0) {
              let i = selectedItems.findIndex(
                (x) => x.objectId === item.objectId
              )
              if (i != -1) {
                item.selected = true
              } else {
                item.selected = false
              }
            } else {
              item.selected = false
            }
            let inDoc = (this.items || []).findIndex(x => (x.productPLU?.objectId || x.productPLU?.id) === item.objectId) !== -1
            if (inDoc) { item.selected = true; item.inDocument = true } else { item.inDocument = false }
            const unit = item.unit || {}
            const category = item.category || {}
            item.unitName = unit.name || '-'
            item.categoryName = category.name || '-'
            item.indexColor = util.generateColor(item.ProductSKU.indexColor)
            if (!item.deleted_at) {
              newData.push(item)
            }
          })
          this.autoCompleteResult = newData
          this.all = newData.length > 0 && newData.every(item => item.selected)
        })
        .catch((e) => {
          this.alert = true
          console.log(e)
        })
      // }
    },
    formSubmit(e) {
      this.loadingButton = false
      this.shop = this.shops.find((i) => i.objectId === this.shopObjectId)
      e.preventDefault()

      const plan = this.users.currentPlan
      this.items.forEach((item) => {
        delete item.remoteImagePath
        delete item.indexColor
      })

      let data = {
        billNo: this.billNo,
        date: new Date(this.datetime).toISOString(),
        discount: util.currencyStringToNumber(this.discount),
        grandTotal: util.currencyStringToNumber(this.grandTotal),
        isVatIncluded: !this.isVatIncluded,
        netTotal: this.netTotal,
        note: this.note,
        shop: {
          id: this.shop.id,
          objectId: this.shop.objectId,
          shopName: this.shop.shopName,
          branchName: this.shop.branchName,
        },
        shopId: this.shop.id,
        stockDocType: 1,
        vatBase: 7,
        uid: this.uid,
        vat: this.vat,
        items: this.items,
        vatType: this.vatType,
        isAVGCost: this.isAVGCostCalc

      }

      if (this.member != null) {
        data['customerId'] = this.member.id || ''
        data['customer'] = {
          id: this.member.id || '',
          objectId: this.member.objectId || '',
          name: this.member.name || '',
        }
      }

      const headers = { shopObjectId: util.sanitizeShopObjectId(this.$store.getters.shopObjectId) }
      if (data.shopId != undefined && data.items.length != 0) {
        axios({
          method: 'post',
          url: '/api/v1.0/' + data.uid + '/stockdocument/save',
          params: { shopObjectId: data.shopObjectId, plan: plan },
          data: data,
          headers: headers,
        })
          .then(() => {
            // setTimeout(() => {
            //   (this.isSuccess = true),
            this.isSuccess = true
            this.$router.push('/inventory/stock-in')
            // }, 5000);
          })
          .catch(function (error) {
            console.log(error)
          })
      }
    },
    onCheckboxChange() {
      let selectedData = JSON.parse(JSON.stringify(this.selectedItems));
      let items = JSON.parse(JSON.stringify(this.items));
      let isshowAlert = 0;
      let newItems = selectedData
        .filter(item => item.selected) 
        .map((item, index) => {
          let SKURatio = item.SKURatio ?? 1;
          let stdCost = item.ProductSKU?.stdCost ?? item.productSKU?.stdCost ?? 0;
          let totalCost = SKURatio * stdCost;
          let checkCount = item.checkCount ?? 0;
          let vatType = item.ProductSKU?.vatType || item.productSKU?.vatType || item.vatType;

          let newItem =  {
            cost: totalCost,
            discount: 0,
            orderIndex: index,
            productPLU: {
              id: item.id ?? "-",
              objectId: item.productPLU?.objectId ?? item.objectId ?? "-",
              PLUCode: item.PLUCode ?? "-",
              name: item.name ?? "-",
              unit: item.unit ?? "-",
              SKURatio: SKURatio,
            },
            productPLUId: item.id ?? "-",
            quantity: checkCount,
            total: 0,
            productSKUObjectId: item.ProductSKU?.objectId ?? item.productSKU?.objectId ?? "-",
            productSKU: item.ProductSKU || item.productSKU || {},
            remoteImagePath: item.remoteImagePath || "",
            indexColor: util.generateColor(item.indexColor),
            vatType: vatType,
          };
          if (item.docNo) {
            newItem.docNo = item.docNo;
          }

          return newItem;
        });


      newItems.forEach(newItem => {
        let isDuplicate = items.some(
          (x) => x.productPLU?.objectId === newItem.productPLU?.objectId
        );

        if (!isDuplicate) {
          this.$set(items, items.length, newItem)
        }
      });


      this.isshowAlert = isshowAlert;
      this.items = items;
      this.selectedItems = [];
      this.AddProductModal = false;
      this.AddCheckStockModal = false;
      this.AddPOModal = false;
      this.all = false;
    },
    setAll() {
      let select = this.selectedItems
      let data = this.autoCompleteResult
      let isshowAlert = 0

      // this.selectedItems = []
      if (this.all) {
        this.checkAllAlert = true
        data.forEach((item) => {
          if (item.inDocument) return
          let cont = select.length
          if (cont < 200) {
            item.selected = true
            if (select.findIndex(x => x.objectId === item.objectId) === -1) select.push(item)
          } else {
            this.checkAllAlert = false
            isshowAlert = 5
          }
        })
      } else {
        data.forEach((item) => {
          if (item.inDocument) return
          item.selected = false
          let i = select.findIndex((x) => x.objectId === item.objectId)
          if (i != -1) {
            select.splice(i, 1)
          }
        })
      }
      this.isshowAlert = isshowAlert
      this.selectedItems = select
      this.autoCompleteResult = data
    },
    currencyFormat(number) {
      return util.convertCurrency(number)
    },
    floatValue(value) {
      return parseFloat(value)
    },
    async fetchDocuments() {
      const uid = this.uid;
      const shopObjectId = this.shopObjectId;
      const params = { shopObjectId: shopObjectId };
      let url = "http://localhost:3003/po/alldoc";

      const headers = { shopObjectId: this.$store.getters.shopObjectId };

      await axios
        .get(url, { params, headers })
        .then((res) => {
          this.documents = res.data || [];
          this.componentIndex = this.componentIndex + 1;
        })
        .catch((error) => {
          console.error("Error fetching documents:", error);
        });
    },
    getStatusColor(status) {
      switch (status) {
        case "Completed":
          return "status-success"; 
        case "Canceled":
          return "status-danger"; 
        case "Pending":
          return "status-light"; 
        case "In Progress":
          return "status-primary";
        default:
          return "status-light";
      }
    },
    selectPO(item) {
      if (this.refDocPO === item.docNo) {
        this.refDocPO = null;
        this.refDocCreateAt = null;
        this.selectedItems = [];
        this.items = [];
        this.$set(item, "selected", false);
        return;
      }

      this.selectedItems = [];
      this.items = [];
      this.refDocPO = item.docNo;
      this.refDocCreateAt = item.createdDate;

      let parsedItems = JSON.parse(JSON.stringify(item.items || []));

      if (!Array.isArray(parsedItems) || parsedItems.length === 0) {
        return;
      }

      this.processedDocuments.forEach(doc => this.$set(doc, "selected", false));
      this.$set(item, "selected", true);

      this.selectedItems = parsedItems.map((docItem, index) => ({
        docNo: item.docNo,
        orderIndex: index,
        PLUCode: docItem.productPLU?.PLUCode || "-",
        name: docItem.productPLU?.name || "-",
        productPLU: docItem.productPLU || {},
        productSKU: docItem.productSKU || {},
        checkCount: docItem.quantity || 0,
        vatType: docItem.productSKU?.vatType || "V",
        cost: docItem.cost || 0,
        discount: docItem.discount || 0,
        total: docItem.total || 0,
        supplier: docItem.supplier || null,
        remoteImagePath: docItem.remoteImagePath || "",
        indexColor: docItem.productSKU?.indexColor || "#cccccc",
        selected: true,
        objectId: docItem.productPLU?.objectId
      }));
    },
    saveCompleted(e) {
      this.modalSavePO = false;
      this.formSubmit(e);
    },
    saveContinue(e) {
      this.modalSavePO = false;
      this.formSubmit(e);
    }
  },
}
</script>
<style scoped>
.no-border-radius-left {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-right: none;
}

.no-border-radius-right {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.multiselect__tags {
  min-height: 35px;
  padding: 0px 40px 0 8px;
}

.multiselect__placeholder {
  margin-top: 6px;
  margin-bottom: 7px;
}

.multiselect__single {
  margin-top: 6px;
  padding-left: 5px;
  margin-bottom: 8px;
}

.modal-body {
  max-height: calc(100vh - 200px);
  overflow-y: auto;
}

/* Hidden arrow  */
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.status-success {
  background-color: rgba(40, 167, 69, 0.5) !important; /* Success จาง */
  color: #155724; 
  border-radius: 10px;
}

.status-danger {
  background-color: rgba(220, 53, 69, 0.5) !important; /* Danger จาง */
  color: #721c24;
  border-radius: 10px;
}

.status-light {
  background-color: #e0e0e0 !important; /* Light */
  color: #6c757d;
  border-radius: 10px;
}

.status-primary {
  background-color: rgba(0, 123, 255, 0.5) !important; /* Primary จาง */
  color: #004085;
  border-radius: 10px;
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="../../../assets/styles/inventory.css" scoped></style>
